import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ConfirmationPage from "./components/ConfirmationPage";
import PDFViewer from "./components/PDFViewer";

// Protected route component
const ProtectedRoute = ({ children }) => {
  const hasAccess = sessionStorage.getItem("pdfAccess");

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ConfirmationPage />} />
        <Route
          path="/blueprint-view-pdf"
          element={
            <ProtectedRoute>
              <PDFViewer />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
